import React, {useCallback, useEffect, useRef, useState} from "react";
import ItemsHorizontalScroll from "../../../../../cap17drive/shared/itemsHorizontalScroll/itemsHorizontalScroll";
import ItemTmdbBtnV2, {ItemTbdbBtnV2Props} from "../../../../../shared/itemTmdbBtnV2/itemTmdbBtnV2";
import {Spinner, TitlePage} from "../../../../../shared";
import {TmdbItemNotesPagination, UserTmdbNotesItem} from "./types";
import {getLocalDateTimeString} from "../../../../../../utils/utils";
import UseSquadflixNavigate from "../../../../../cap17drive/squadflixHome/useSquadflixNavigate";
import {ScrollModalApi} from "../../../../../shared/scroll-modal/view";
import {ScrollModal} from "../../../../../shared/scroll-modal";
import TmdbResultCard from "../../../../../cap17drive/tmdbResultCard/tmdbResultCard";
import {Link} from "react-router-dom";
import {SquadflixLogsApi} from "../../../../../../apis/squadflix-logs/SquadflixLogsApi";

const MyProfileNotes = () => {

    const squadflixNav = UseSquadflixNavigate({});
    const [pagination, setPagination] = useState<TmdbItemNotesPagination>(undefined);
    const [initialLoading, setInitialLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    const [loadingNextPage, setLoadingNextPage] = useState(false);
    const loadedPages = useRef<Record<number, TmdbItemNotesPagination>>({});
    const itemsRef = useRef<ItemTbdbBtnV2Props[]>([]);
    const [items, setItems] = useState<ItemTbdbBtnV2Props[]>([]);
    const loadingPageNumRef = useRef(0);
    const lastPageRef = useRef(0);
    const [selectedItem, setSelectedItem] = useState<UserTmdbNotesItem>(null);
    const itemDetailsScrollModal = useRef<ScrollModalApi>(null);

    const fetchPage = useCallback(async (page: number) => {
        setLoading(true);
        loadingPageNumRef.current = page;
        return SquadflixLogsApi.getMyNotedItems({page, query: undefined}).then((res: TmdbItemNotesPagination) => {
            setPagination(res);
            lastPageRef.current = page;
            setLoading(false);
            setInitialLoading(false);
        }).catch(e => {
            setLoading(false);
        });
    }, [setLoading]);

    useEffect(() => {
        setInitialLoading(true);
        fetchPage(1);
    }, [fetchPage]);

    const navigateToItem = (item: UserTmdbNotesItem) => {
        item.isMovie
            ? squadflixNav.navigateToMovie(item.item)
            : squadflixNav.navigateToSerie(item.item);
    }

    const handleSelectItem = (item: UserTmdbNotesItem) => {
        setSelectedItem(item);
        itemDetailsScrollModal.current?.open();
    }

    useEffect(() => {
        if (!pagination) return;
        if (loadingNextPage) {
            if (!itemsRef.current.some(x => x.loading)) {
                itemsRef.current.push({tmdbItem: undefined, loading: true});
                setItems([...itemsRef.current]);
            }
            return;
        }

        const loadingIndex = itemsRef.current.findIndex(x => x?.loading);
        if (loadingIndex !== -1) {
            itemsRef.current.splice(loadingIndex, 1);
        }

        if (loadedPages.current[pagination.page]) return;

        itemsRef.current.push(...pagination.items.map((item) => ({
            tmdbItem: item.item,
            onClick: () => {
                handleSelectItem(item);
            },
            bottomInfo: <>
                {!item.isMovie && item.episodes?.length + (item.notes?.length ? 1 : 0)}
                <i className="fa-regular fa-note-sticky ps-1"></i>
            </>,
            type: item.isMovie ? 'movie' : 'tv' as ItemTbdbBtnV2Props["type"],
            description: getLocalDateTimeString(item.noteModifiedDate)
        })));
        loadedPages.current[pagination.page] = pagination;
        setItems([...itemsRef.current]);

    }, [loadingNextPage, pagination, squadflixNav]);


    const handleLoadNextPage = useCallback(() => {
        if (!loadedPages.current[1]) return;
        const lastPagination = loadedPages.current[Object.keys(loadedPages.current).length];
        if (lastPagination.page >= lastPagination.totalPages) return;
        if (loadingPageNumRef.current > lastPageRef.current) return;
        setLoadingNextPage(true);
    }, []);

    useEffect(() => {
        if (loading) return;
        if (!loadingNextPage) return;
        if (!pagination) {
            setLoadingNextPage(false);
            return;
        }
        if (pagination.page >= pagination.totalPages) {
            setLoadingNextPage(false);
            return;
        }
        fetchPage(pagination.page + 1).then(() => {
            setLoadingNextPage(false);
        });

    }, [loadingNextPage, loading, pagination, fetchPage]);


    if (initialLoading) {
        return <div style={{height: "272px", overflow: "hidden"}}>
            <TitlePage
                title={<span>Tus notas</span>}
                icon="fa-solid fa-note-sticky"
                leftClass="col-12"
                disableScroll
                hideSeparator
                titleClass="mb-2 ps-1"
                fixedHeight="27px" rightOptions={undefined} rightClass={undefined} className={undefined}
                style={undefined}/>
            <div className="d-flex justify-content-center align-items-center" style={{
                padding: "20px",
                height: "237px",
            }}>
                <Spinner className={undefined}/>
            </div>
        </div>;
    }

    return (
        <>
            <div style={{height: "fit-content", overflow: "hidden"}}>
                <TitlePage
                    title={<span>Tus notas</span>}
                    icon="fa-solid fa-note-sticky"
                    leftClass="col-12"
                    disableScroll
                    hideSeparator
                    titleClass="mb-2 ps-1"
                    fixedHeight="27px" rightOptions={undefined} rightClass={undefined} className={undefined}
                    style={undefined}/>
                <ItemsHorizontalScroll onScrollEnd={handleLoadNextPage}>
                    {
                        items.map((item, index) => (
                            <ItemTmdbBtnV2
                                key={index}
                                {...item}
                            />
                        ))
                    }
                    {items.length === 0 && <div className="text-muted" style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "227px",
                    }}>Aquí verás las notas que añadas a episodios, series o películas.</div>}
                </ItemsHorizontalScroll>
            </div>
            <ScrollModal ref={itemDetailsScrollModal} header={selectedItem &&
                <div>
                    <TmdbResultCard props={selectedItem.item} from={undefined}
                                    customBottomInfo={
                                        <div className="text-muted" style={{fontSize: '0.9em'}}>
                                            Nota modificada el {getLocalDateTimeString(selectedItem.noteModifiedDate)}
                                        </div>
                                    }
                                    onClick={() => {
                                        navigateToItem(selectedItem);
                                    }}/>
                </div>

            }>
                {selectedItem && <div style={{padding: "20px 0"}}>
                    {!!selectedItem.notes?.length && <div style={{
                        marginBottom: '20px',
                        whiteSpace: 'pre-wrap',
                        fontSize: '0.9em',
                    }}>
                        {selectedItem.notes}
                    </div>}
                    {!selectedItem.isMovie && selectedItem.episodes && selectedItem.episodes.length > 0 &&
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th>
                                    Episodio
                                </th>
                                <th>
                                    nota
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {selectedItem.episodes.map((ep, idx) => (
                                <tr key={`S${ep.season}E${ep.episode}`}>
                                    <td style={{verticalAlign: 'middle'}}>
                                        <Link
                                            className="link-body-emphasis link-offset-2 link-underline-opacity-25 link-underline-opacity-75-hover"
                                            to={`/squadflix/series/${selectedItem.item.id}/${ep.season}/${ep.episode}`}>
                                            S{ep.season}E{ep.episode}
                                        </Link>
                                    </td>
                                    <td>
                                        <div style={{
                                            whiteSpace: 'pre-wrap',
                                            fontSize: '0.9em',
                                        }}>
                                            {ep.notes}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>

                        </table>
                    }
                </div>}
            </ScrollModal>
        </>
    );

}

export default MyProfileNotes;
